// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2197":"56ad2fd3ac624430","2888":"73fc7b13d8fca112","9469":"f6617d284e616ddb"}[chunkId] + ".css";
};